// extracted by mini-css-extract-plugin
export default {"sliderContainer":"index_sliderContainer_c7bNC","dot":"index_dot_Yun6B","current":"index_current_uH-uZ","li":"index_li_QdjAk"};